console.log("BI Custom JS file loaded successfully!");

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.monthly-subscription').forEach(function(element) {
        element.addEventListener('click', function(event) {
            event.preventDefault();
            console.log('monthly-subscription was clicked');
            addItemToCartMonthlySubscription();
        });
    });
});

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.annual-subscription').forEach(function(element) {
        element.addEventListener('click', function(event) {
            event.preventDefault();
            console.log('annual-subscription was clicked');
            addItemToCartAnnualSubscription();
        });
    });
});

function addItemToCartMonthlySubscription() {
    let formData = {
     'items': [{
      'id': 12952261623869,
      'quantity': 1,
      'selling_plan': 711925006717
      }]
    };

    fetch('https://store.builtintelligence.com/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        return response.json();
    })
    .then((data) => {
        console.log('Response from Shopify:', data);
        console.log('Monthly Subscription Added', formData);
        window.location.href = '/cart';
    })
    .catch(error => {
        console.error('There was a problem with the fetch operation:', error);
    });
}

function addItemToCartAnnualSubscription() {
    let formData = {
     'items': [{
      'id': 33005627506749,
      'quantity': 1,
      'selling_plan': 711925203325
      }]
    };

    fetch('https://store.builtintelligence.com/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        return response.json();
    })
    .then((data) => {
        console.log('Response from Shopify:', data);
        console.log('Annual Subscription Added', formData);
        window.location.href = '/cart';
    })
    .catch(error => {
        console.error('There was a problem with the fetch operation:', error);
    });
}
